import { routes } from '@/shared/routes';

type Tone = 'default' | 'inverse';

interface Props {
  tone: Tone;
}

const textClasses: Record<Tone, string> = {
  default: 'text-slate-900',
  inverse: 'text-white',
};

export default function BrandLink({ tone }: Props) {
  return (
    <a href={routes.root} aria-label="Skip Visa Queue" className="flex items-center gap-3">
      <span className="grid h-11 w-11 place-items-center rounded-lg bg-white p-1 shadow-sm">
        <img src="/logo.svg" alt="Skip Visa Queue" className="h-full w-full" />
      </span>
      <span className={`text-sm font-semibold ${textClasses[tone]}`}>Skip Visa Queue</span>
    </a>
  );
}
